<ul class="breadcrumb">

  <li *ngFor="let b of currentRoute$ | async;let last = last" class="breadcrumb-item">
    <a *ngIf="last; else notLast" class="lastBreadCrumb">{{b.description}}</a>
    <ng-template #notLast>
      <a [routerLink]="b.path">{{b.description}}</a>
    </ng-template>
  </li>

</ul>
